// extracted by mini-css-extract-plugin
export default {"title":"LoadingTeachers_title__kMVUN","box":"LoadingTeachers_box__f2EbI","total":"LoadingTeachers_total__pVOPF","noData":"LoadingTeachers_noData__K2WZS"};